'use client'

import { Button } from '@/components/ui/button'
import { DateUtil } from '@/lib/utils/date'
import { logger } from '@/lib/logger'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const t = useTranslations('global_error')
  const time = new Date().toISOString()
  const currentUrl = (() => {
    if (typeof window === 'undefined') return ''
    try {
      return decodeURI(window.location.href)
    } catch {
      return window.location.href
    }
  })()

  useEffect(() => {
    logger.captureException(error as Error)
  }, [error])

  return (
    <div className='flex h-[calc(100vh-200px)] w-screen items-center justify-center overflow-hidden'>
      <div className='text-center'>
        <h1 className='mb-6 text-2xl font-medium'>{t('error_title')}</h1>

        <Button
          onClick={() => {
            window.location.replace(`/`)
          }}
          variant='white'
        >
          {t('home')}
        </Button>

        <Button
          onClick={() => {
            reset()
          }}
          variant='outline-neutral'
        >
          {t('retry')}
        </Button>
        <p className='mt-8 text-xs text-neutral-700'>URL: {currentUrl}</p>
        <p className='text-xs text-neutral-700'>
          Time: {DateUtil.formatFull(time)}
        </p>
      </div>
    </div>
  )
}
